import a from "../../../helpers/AxiosURLSearchParams.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
